module.exports = __webpack_public_path__ + "static/media/bruges.eb6f5b4c.jpeg";